import React, { useEffect } from 'react';
import './movements-wall-chart.scss';
import { useDispatch, useSelector } from "react-redux";
import { MediumLoadingSpinner } from "../../atoms/LoadingSpinner";
import { Center } from "../../atoms/StructuralLayout";
import MovementsList from "./components/team-movements-list/MovementsList";
import { BodyRegular } from "../../atoms/fonts/Body";
import { selectCalendarDate } from '@shared/store/dashboard.duck';
import { DATE_FORMAT } from '@shared/utils/DateUtils';
import { HeadlineSmall } from "../../atoms/fonts/Headline";
import styled from "styled-components";
import { WhereaboutsGroupType } from '@features/whereabouts/models/movements.models';
import {
  loadFavouritedUsersWhereabouts,
  selectFavouritedUsersWhereabouts,
  selectIsFavouritedUsersWhereaboutsOptionSelected,
  selectIsLoading
} from '@features/whereabouts/store/FavouritedUsersWhereabouts.duck';

interface TeamWallChartProps {
  enabledSetMovements: boolean;
  excludeCurrentUser?: boolean;
}

export function FavouritedUsersWallChart(props: TeamWallChartProps) {
  const {enabledSetMovements, excludeCurrentUser} = props;
  const dispatch = useDispatch();
  const calendarDate = useSelector(selectCalendarDate);
  const dateString = calendarDate?.format(DATE_FORMAT);
  const whereabouts = useSelector(selectFavouritedUsersWhereabouts);
  const isVisible = useSelector(selectIsFavouritedUsersWhereaboutsOptionSelected);
  const loading = useSelector(selectIsLoading);

  useEffect(() => {
    if (isVisible) {
      dispatch(loadFavouritedUsersWhereabouts({date: dateString}));
    }
  }, [dateString, isVisible, dispatch]);

  if (!isVisible) {
    return null;
  }

  return (
    <Container>
      {loading ?
        <>
          <Center style={{marginTop: 16}}>
            <MediumLoadingSpinner hideBorder={true} />
          </Center>
        </>
        :
        <>
          <HeadlineSmall>Your favourited users</HeadlineSmall>
          {whereabouts?.length > 0 ?
            <MovementsList movements={whereabouts} enableSetMovements={enabledSetMovements} groupId={WhereaboutsGroupType.FavouritedUsers} excludeCurrentUser={excludeCurrentUser} /> :
            <BodyRegular>You have no favourite users</BodyRegular>
          }
        </>
      }
    </Container>
  )
}

const Container = styled.div`
  margin-bottom: 24px;
`
